import VRPulseIndicator from "@Components/game/common/vr-pulse-indicator";
import { useReleaseNotes } from "@Context/common/release-notes/release-notes-context";

interface IVRReleaseNotesIndicator {
  size?: number;
  color?: string;
}

/**
 * A pulsing indicator that shows when there are unseen release notes
 */
const VRReleaseNotesIndicator = ({ size = 12, color }: IVRReleaseNotesIndicator) => {
  const { hasUnseenNotes } = useReleaseNotes();

  if (!hasUnseenNotes) {
    return null;
  }

  return <VRPulseIndicator color={color} size={size} />;
};

export default VRReleaseNotesIndicator;
